import React, { useEffect, useState } from 'react';
import FilterRange from './FilterRange';

const Filter = ({ type, data, query, handleFilter, handleSlider }) => {
  const [vals, setVals] = useState('');

  useEffect(() => {
    const arr = Object.values(data.value);

    arr.sort((a, b) => {
      const x = a.weight;
      const y = b.weight;
      return x < y ? -1 : x > y ? 1 : 0;
    });

    setVals(arr);
  }, [data]);

  const checkQuery = (field, val) => {
    // If field__val is in query, return true.
    const needle = Object.keys(query).some(
      (el) => query[el].field === field && query[el].tid === val
    );

    return needle;
  };

  return (
    <>
      {type === 'number' && (
        <FilterRange data={data} handleSlider={handleSlider} query={query} />
      )}
      {type !== 'number' && (
        <ul>
          {Object.keys(vals).map((el) => (
            <li key={vals[el].id} data-active={vals[el].active}>
              <input
                id={`a11y-issue--${vals[el].field}-${vals[el].id}`}
                type="checkbox"
                data-field={vals[el].field}
                data-tid={vals[el].id}
                data-type={vals[el].type}
                data-status={vals[el].active}
                onClick={(e) => handleFilter(e.target)}
                checked={
                  checkQuery(vals[el].field, vals[el].id) ? 'checked' : ''
                }
                onChange={(e) => {}}
              />
              <label htmlFor={`a11y-issue--${vals[el].field}-${vals[el].id}`}>
                {vals[el].name}
              </label>
            </li>
          ))}{' '}
        </ul>
      )}
    </>
  );
};

export default Filter;
